
import './App.css';
import Main from './Components/Main';
import Navbar from './Components/Navbar';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PrivacyPolicy from './Components/PrivacyPolicy';
import SupportForm from './Components/SupportForm';
import Card from './Components/Card';
import Press from './Components/Press';
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';
import { useRef } from 'react';
import Applicationform from './Components/Applicationform';
import TrainingForm from './Components/TrainingForm';
import Login from './Components/Login';
function App() {
  const tawkMessengerRef = useRef();

    const handleMinimize =() => {
      tawkMessengerRef.current.minimize();
  };
    const onLoad = () => {
      console.log('onLoad works!');
  };

  return (
    <div className="App">
      <Navbar/>
      
      <Router>
        <Routes>
          <Route path='/' element={<Main/>} />
          <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>
          <Route path='/support-form' element={<SupportForm/>}/>
          <Route path='/Applicationform' element={<Applicationform/>}/>
          <Route path='/TrainingForm' element={<TrainingForm/>}/>
          <Route path='/Login' element={<Login/>}/>
          <Route path='/Card' element={<Card/>} />
          <Route path='/press' element={<Press/>}/>

        </Routes>

        <button onClick={handleMinimize}></button>
        <TawkMessengerReact
                propertyId="647b7d097957702c744b98b8"  widgetId ="1h2160ri8" 
                ref={tawkMessengerRef}
                onLoad={onLoad}/>
      </Router>
    </div>
  );
}
export default App;



